import React from "react";
import { useNavigate } from "react-router-dom";
import "./SidebarHeader.css";
import rLogo from "../../../assets/R.svg";
import rNameLogo from "../../../assets/Reppi.svg";

function SidebarHeader({ isCollapsed, onToggle }) {
  const navigate = useNavigate();

  const handleLogoClick = () => {
    navigate("/dashboard");
  };

  return (
    <div className="sidebar-header">
      <div className="sidebar-logo" onClick={handleLogoClick}>
        <img
          src={isCollapsed ? rLogo : rNameLogo}
          alt="Reppi"
          className="sidebar-logo-image"
        />
      </div>
      <button
        className="sidebar-toggle"
        onClick={onToggle}
        onKeyDown={e => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            onToggle();
          }
        }}
        aria-label="Toggle sidebar (Ctrl+B)"
        aria-expanded={!isCollapsed}
        title="Toggle sidebar (Ctrl+B)"
        tabIndex={0}
      >
        <span className="material-icons">
          {isCollapsed ? "menu" : "menu_open"}
        </span>
      </button>
    </div>
  );
}

export default SidebarHeader;
